module.exports = __webpack_public_path__ + "img/icon-photon.bc2fa965.png";